import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class RichTextPreviewer extends Vue {
	@Prop({ default: null }) content!: string;
}
